<ng-template #childTemplate>
    <div class="table-row groupers">
        <div class="table-column ticket-filters">
            <app-input class="filter-input"
                       label="{{ 'table.groupFilter' | translate }}"
                       placeholder="{{'generic.components.locationPicker.nameInputPlaceholder' | translate}}"
                       [(ngModel)]="toolName"
                       (ngModelChange)="onNameChanged()"></app-input>
            <app-tool-scan [label]="'table.groupFilter' | translate"
                           [placeholder]="'service.tickets.table.scanTool' | translate"
                           [(ngModel)]="scanDefaultValue"
                           (scanEvent)="onToolScan($event)">
            </app-tool-scan>
            <ul class="main-lines">
                <li class="group-item">
                    <app-dropdown-autocomplete
                        [(ngModel)]="lineSelectedValue"
                        (selectItem)="onGroupFilterChanged($event)"
                        [isNgModel]="true"
                        [items]="linesItems"
                        [label]="'admin.tools.table.grouping.options.line' |translate"
                        [valueField]="'id'"
                        [displayField]="'name'"
                        [appendTo]="'body'"
                        [emptyText]="'admin.tools.table.grouping.options.line' |translate"
                        [isFirstSelectable]="false">
                    </app-dropdown-autocomplete>
                </li>
            </ul>
        </div>
    </div>
</ng-template>
<app-table [data]="tickets"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [saveFilters]="true"
           [groupableColumns]="true"
           [definedGroupers]="true"
           [showGroupFilters]="hasFilters"
           [showFilters]="hasFilters"
           [showGroupers]="hasFilters"
           [isFilterExpanded]="hasFilters"
           [displayToggleFilters]="false"
           [hasPagination]="true"
           [hasTitle]="hasTitle"
           [isMaterial]="isMaterial"
           [headerBackgroundColor]="headerBackgroundColor"
           [title]="'service.tickets.table.title' | translate"
           [childTemplate]="childTemplate"
           (filterChange)="onFilterChange()"
           (sortChange)="onSortChange($event)"
           (pageChange)="onPageChange($event)">

    <app-table-column [header]="'service.tickets.table.columns.id' | translate"
                      field="id"
                      sortable="true"
                      [filter]="false">
        <ng-template #filter let-column="column" let-table="table">
            <app-input type="number"
                       mask="0*"
                       [placeholder]="'admin.tickets.table.filter.placeholder.id' | translate"
                       [(ngModel)]="column.filterValue"
                       (ngModelChange)="table.onFilterChange(column)">
            </app-input>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'service.tickets.table.columns.date' | translate"
                      sortable="true"
                      field="createdDate">
        <ng-template #filter let-column="column" let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  [appendTo]="'body'"
                                  [placeholder]="'admin.tickets.table.filter.placeholder.createdDate' | translate"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'service.tickets.table.columns.createdBy' | translate"
                      [filterPlaceholder]="'admin.tickets.table.filter.placeholder.createdBy' | translate"
                      [sortable]="true"
                      [filter]="true"
                      field="createdBy">
        <ng-template #body
                     let-ticket="rowData">
            <span>{{ ticket.createdByName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'service.tickets.table.columns.status' | translate"
                      [sortable]="true"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterStatusList"
                          valueField="value"
                          displayField="name"
                          [emptyText]="'admin.tickets.table.filter.placeholder.status' | translate"
                          (selectItem)="onStatusFilterChange(column, table)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-ticket="rowData">
            <span>{{ ticket.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'service.tickets.table.columns.location' | translate"
                      [sortable]="false"
                      field="hasMaintenanceAtLine">
        <ng-template #filter let-column="column" let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterLocationList"
                          valueField="value"
                          displayField="name"
                          [emptyText]="'service.tickets.table.findByLocation' | translate"
                          (selectItem)="onLocationFilterChange(column, table)">
            </app-dropdown>
        </ng-template>
        <ng-template #body
                     let-ticket="rowData">
            <span> {{ ticket.hasMaintenanceAtLine ? ticket.line.name : ('service.tickets.table.serviceArea' | translate) }}</span>
        </ng-template>

    </app-table-column>
    <app-table-column [header]="'service.tickets.table.columns.mainLine' | translate"
                      [sortable]="false"
                      field="mainLine">
        <ng-template #body
                     let-ticket="rowData">
            <span> {{ ticket.mainLines }}</span>
        </ng-template>

    </app-table-column>

    <app-table-column [header]="'lift-operator.incoming-tools-table.actions' | translate">
        <ng-template
            #body
            let-ticket="rowData">

            <app-button
                *ngIf="ticket.status === 'New'"
                type="primary"
                class="action-button"
                (clicked)="onRequestTools(ticket.id)">{{ 'generic.buttons.requestTools' | translate }}
            </app-button>

            <app-button
                *ngIf="ticket.status !== 'New'"
                type="warning"
                class="process-button"
                (click)=onResumeProcess(ticket)>
                {{ "lift-operator.incoming-tools-table.resumeProcess" | translate | uppercase }}
            </app-button>
        </ng-template>
    </app-table-column>

    <app-table-column
                      sortable="true"
                      field="hasPriority">
        <ng-template #body let-ticket="rowData">
            <app-tooltip
                        *ngIf="ticket.hasPriority"
                        type="success"
                         record="{{'admin.tickets.table.ticketPriority' | translate}}">
            </app-tooltip>
        </ng-template>
    </app-table-column>
</app-table>

<app-confirmation-modal (scanEvent)="onScanBadge($event)"
                        [title]="modalTitle"
                        [question]="modalQuestion"
                        [message]="modalMessage"
                        [isCustomContent]="true">

    <div class="row" *ngIf="ticket.ticketOperations" modal-custom-content>
        <div class="row">
            <div class="col s12">
                <app-tool-scan-tree
                    [labelText]="'service.tickets.details.tools.label' | translate"
                    [emptyMessage]="'service.tickets.details.tools.emptyText' | translate"
                    [loading]="isLoading"
                    [items]="ticket.ticketTools">
                </app-tool-scan-tree>
            </div>
        </div>
    </div>

</app-confirmation-modal>
